<template>
  <nav class="navigator">
    <transition name="toggle-navigator">
      <div class="navigator__container" v-if="menuOpen" @click="testCloseMenu">
        <router-link
          class="navigator__voice"
          :to="`/${$store.state.lang}/${$store.state.lang === 'en' ? 'projects' : 'progetti'}`"
          v-html="`${$store.state.lang === 'en' ? 'Projects' : 'Progetti'}`"
        />
        <router-link
          class="navigator__voice"
          :to="`/${$store.state.lang}/${$store.state.lang === 'en' ? 'services' : 'servizi'}`"
          v-html="`${$store.state.lang === 'en' ? 'Services' : 'Servizi'}`"
        />
        <router-link
          class="navigator__voice"
          :to="`/${$store.state.lang}/studio`"
        >
          Studio
        </router-link>
        <router-link
          class="navigator__voice"
          :to="`/${$store.state.lang}/${$store.state.lang === 'en' ? 'contacts' : 'contatti'}`"
          v-html="`${$store.state.lang === 'en' ? 'Contacts' : 'Contatti'}`"
        />
      </div>
    </transition>

    <Logo class="navigator__logo" />

    <div class="navigator__actions">
      <div
        :class="[
          'navigator__dot',
          menuOpen ? 'navigator__dot--active' : ''
        ]"
        @click="$store.state.menuOpen = !menuOpen"
      >
        <span class="dot__text" v-html="menuOpen ? 'Close' : 'Menu'"></span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 27">
          <circle class="dot__circle" cx="13.5" cy="13.5" r="4" fill="#231f20"/>
          <circle
            class="dot__border"
            cx="13.5"
            cy="13.5"
            r="12.5"
            fill="none"
            stroke="#231f20"
            stroke-miterlimit="10"
            stroke-width="2"
          />
        </svg>
      </div>
      <ChangeLang/>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex';

import Logo from '@/components/Logo.vue';
import ChangeLang from '@/components/ChangeLang.vue';


export default {
  name: 'navigator',

  components: {
    Logo,
    ChangeLang,
  },

  computed: {
    ...mapState(['menuOpen']),
  },

  methods: {
    testCloseMenu(event) {
      if (event.target.classList.contains('navigator__container')) {
        this.$store.state.menuOpen = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";
@import '../style/colors';
@import '../style/variables';
@import '../style/functions';


.navigator {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 30px 20px 0;

  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: space-between;

  z-index: z-index(header);
  pointer-events: none;

  @include mq(mobileL) {
    flex-flow: row wrap;
    justify-content: space-between;

    padding: 60px 65px 0;
  }

  &__actions {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }

  &__logo {
    display: inline-block;

    position: relative;
    height: 18px;
    pointer-events: all;

    @include mq(d) {
      height: 22px;
    }

    @include mq(dm) {
      height: 28px;
    }

    @include mq(dl) {
      height: 32px;
    }

    @include mq(dxl) {
      height: 36px;
    }
  }

  &__dot {
    display: inline-block;
    position: relative;
    width: 25px;
    height: 25px;

    cursor: pointer;
    pointer-events: all;

    .dot__text {
      display: inline-block;
      position: absolute;
      left: -50px;
      top: 50%;

      transform: translateY(-50%);

      @include mq(dm) {
        font-size: font-size(s);
      }

      @include mq(dl) {
        left: -80px;
      }
    }

    svg {
      display: inline-block;
      position: relative;
      width: inherit;
      height: inherit;
    }

    .dot__circle {
      transition: transform 0.3s ease-in-out;
      transform-origin: center center;
    }

    .dot__border {
      stroke-dasharray: 78;
      stroke-dashoffset: 78;
      transition: stroke-dashoffset 0.7s ease-in-out,
        transform 0.7s ease-in-out;
      transform-origin: center center;
      transform: rotate(-90deg);
    }

    &:not(.navigator__dot--active):hover .dot__circle {
      transform: scale(1.5);
    }

    &.navigator__dot--active .dot__border {
      stroke-dashoffset: 0;
      transform: rotate(90deg);
    }
  }

  &__container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 100px 20px 20px;

    box-sizing: border-box;
    background-color: white;

    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-flow: column wrap;

    perspective: 800px;
    pointer-events: all;

    @include mq(ipadL) {
      justify-content: space-between;
      flex-flow: row wrap;

      padding: 0 60px;
    }

    & .navigator__voice {
      -webkit-text-stroke: 2px $color-text;
      // text-shadow: -1px 1px 0 $color-text,
      //   1px -1px 0 $color-text,
      //   -1px -1px 0 $color-text,
      //   1px 1px 0 $color-text;
      font-size: font-size(xxl-mobile);

      @include mq(mobileL) {
        font-size: font-size(xxl);
      }

      color: white;
      transition: color 0.3s ease-in-out,
        transform 0.5s ease-in-out 0.5s,
        opacity 0.5s ease-in-out 0.5s;

      &:hover {
        color: $color-text;
      }
    }

    a.router-link-exact-active {
      color: $color-text;
    }

    &.toggle-navigator-enter-active {
      transition: all .5s ease;

      .navigator__voice {
        transition: color 0.3s ease-in-out,
          transform 0.5s ease-in-out 0.5s,
          opacity 0.3s ease-in-out 0.5s;
      }
    }

    &.toggle-navigator-leave-active {
      transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0) 0.2s;

      .navigator__voice {
        transition: color 0.3s ease-in-out,
          opacity 0.3s ease-in-out;
      }
    }

    &.toggle-navigator-enter,
    &.toggle-navigator-leave-to {
      opacity: 0;

      .navigator__voice {
        opacity: 0;
      }
    }

    &.toggle-navigator-enter .navigator__voice {
      transform: translate3d(0, 20px, 20px) rotate3d(1, 0, 0, 90deg);
    }
  }
}
</style>
